export function getTransportationSrc(type: string) {
  const transportation = type.toLocaleLowerCase();

  switch (transportation) {
    case "train":
      return "train_4_line";
    case "plane":
      return "airplane_line";
    case "boat":
      return "boat_line";
    default:
      return null;
  }
}
